import axiosInstance from './axiosInterceptor';
import { CognitoUserPool,CognitoUser, AuthenticationDetails,} from "amazon-cognito-identity-js";

const poolData = {
    UserPoolId: "us-east-2_b4MZsgxkh",
    ClientId: "52d67u01jdbvtspaso00889ne6",
  };
  

const baseUrl = "https://schedulerapi.pricingculture.com/holdings/";
const userPool = new CognitoUserPool(poolData);

class Apis {

    get headers() {
        return {
            // userid: localStorage.getItem("userId"),
            access_token: localStorage.getItem("access_token")
        };
    }

    // loginUser(email, password)
    // {

    // const getJwtExpiry = (token) => {
    //     if (!token) return null;
    //     const payload = JSON.parse(atob(token.split(".")[1]));
    //     return payload.exp * 1000; // seconds → milliseconds
    // };

    // return new Promise((resolve, reject) => {
    //     const authDetails = new AuthenticationDetails({
    //     Username: email,
    //     Password: password,
    //     });
    
    //     const user = new CognitoUser({
    //     Username: email,
    //     Pool: userPool,
    //     });
    
    //     user.authenticateUser(authDetails, {
    //     onSuccess: (session) => {
    //         const idToken = session.getIdToken().getJwtToken();
    //         const accessToken = session.getAccessToken().getJwtToken();
    //         const refreshToken = session.getRefreshToken().getToken();
    //         const accessTokenExpiresAt = getJwtExpiry(accessToken);
    //         resolve({
    //         user,
    //         session,
    //         idToken,
    //         accessToken,
    //         refreshToken,
    //         accessTokenExpiresAt,
            
    //         });
    //     },
    //     onFailure: (err) => {
    //         reject(err);
    //     },
    //     });
    // });
    // };


    loginUser(email, password) {
      const getJwtExpiry = (token) => {
        if (!token) return null;
        const payload = JSON.parse(atob(token.split(".")[1]));
        return payload.exp * 1000;
      };
    
      return new Promise((resolve, reject) => {
        const authDetails = new AuthenticationDetails({
          Username: email,
          Password: password,
        });
    
        const user = new CognitoUser({
          Username: email,
          Pool: userPool,
        });
    
        user.authenticateUser(authDetails, {
          onSuccess: (session) => {
            const idToken = session.getIdToken().getJwtToken();
            const accessToken = session.getAccessToken().getJwtToken();
            const refreshToken = session.getRefreshToken().getToken();
    
            resolve({
              status: "SUCCESS",
              user,
              session,
              idToken,
              accessToken,
              refreshToken,
              accessTokenExpiresAt: getJwtExpiry(accessToken),
            });
          },
    
          onFailure: (err) => {
            reject(err);
          },
    
          // 🔴 IMPORTANT HANDLER
          newPasswordRequired: (userAttributes, requiredAttributes) => {
            delete userAttributes.email_verified;
    
            resolve({
              status: "NEW_PASSWORD_REQUIRED",
              user,
              userAttributes,
              requiredAttributes
            });
          }
        });
      });
    }

    getlogincode(body){
      return axiosInstance.post(baseUrl+'getCode',body)
  }
    

    completeNewPassword(user, newPassword) {
      return new Promise((resolve, reject) => {
        user.completeNewPasswordChallenge(
          newPassword,
          {},
          {
            onSuccess: (session) => {
              const accessToken = session.getAccessToken().getJwtToken();
              const refreshToken = session.getRefreshToken().getToken();
    
              resolve({
                status: "SUCCESS",
                accessToken,
                refreshToken,
                accessTokenExpiresAt: (() => {
                  const payload = JSON.parse(atob(accessToken.split(".")[1]));
                  return payload.exp * 1000;
                })()
              });
            },
            onFailure: reject
          }
        );
      });
    }

    forgotPassword(email) {
      return new Promise((resolve, reject) => {
        const user = new CognitoUser({
          Username: email,
          Pool: userPool
        });
    
        user.forgotPassword({
          onSuccess: () => {
            // Rare but valid
            resolve({ status: "CODE_SENT" });
          },
    
          onFailure: (err) => {
            reject(err);
          },
    
          inputVerificationCode: () => {
            // ✅ OTP sent
            resolve({
              status: "CODE_SENT",
              user
            });
          }
        });
      });
    }

    confirmForgotPassword(user, verificationCode, newPassword) {
      return new Promise((resolve, reject) => {
        user.confirmPassword(verificationCode, newPassword, {
          onSuccess() {
            resolve({ status: "SUCCESS" });
          },
          onFailure(err) {
            reject(err);
          },
        });
      });
    }

    refreshSession = (email) => {
        return new Promise((resolve, reject) => {
          const refreshToken = localStorage.getItem("refreshToken");
      
          if (!refreshToken) {
            reject("No refresh token");
            return;
          }
      
          const user = new CognitoUser({
            Username: email,
            Pool: userPool,
          });
      
          user.refreshSession(
            { getToken: () => refreshToken },
            (err, session) => {
              if (err) {
                reject(err);
              } else {
                const newAccessToken = session.getAccessToken().getJwtToken();
                const newIdToken = session.getIdToken().getJwtToken();
      
                localStorage.setItem("accessToken", newAccessToken);
      
                resolve({
                  accessToken: newAccessToken,
                  idToken: newIdToken,
                });
              }
            }
          );
        });
      };
      
      
    getusers(){
        let id = localStorage.getItem("selected_org_id")
        let headers = {
            access_token: localStorage.getItem("access_token"),
            organization_id  : id?id:localStorage.getItem("organization_id")
        }
        return axiosInstance.get("https://schedulerapi.pricingculture.com/getorgusers",{ headers: headers })
    }

    getAssetById(id)
    {
        return axiosInstance.get(baseUrl+'getAsset?id='+id)
    }

    getHoldings(id){
        return axiosInstance.get(baseUrl+'client/'+id)
    }

    getHoldingById(id){
        return axiosInstance.get(baseUrl+'/'+id)
    }

    uploadImage(holdingId,payload){
        return axiosInstance.post(baseUrl+'/'+holdingId+'/images',payload)
    }

    uploadDocument(holdingId,payload){
        return axiosInstance.post(baseUrl+'/'+holdingId+'/documents',payload)
    }
    

    getCategories()
    {
        return axiosInstance.get(baseUrl+'asset-categories')
    }

    sendOtp(body)
    {
        return axiosInstance.post(baseUrl+'requestOtp',body,{ headers: this.headers })
    }

    getIndices()
    {
        return axiosInstance.get(baseUrl+'getindices')
    }

    getStories(body)
    {
        return axiosInstance.post(baseUrl+'get-stories',body)
    }


    getInsights(body)
    {
        return axiosInstance.post(baseUrl+'get-insights',body)
    }

    getCategoriesForUser(id)
    {
        return axiosInstance.get(baseUrl+`/clients/${id}/categories`)
    }

    userRole(){
        return axiosInstance.get(baseUrl+"get-role",{ headers: this.headers })
    }
    getTerminalOrgs(){
      return axiosInstance.get(baseUrl+'get-terminal-users')
    }
}


export default Apis;